const Constants = {
  JSON_PLACEHOLDER_BASE_URL: 'https://jsonplaceholder.typicode.com',
};

export default Constants;
